/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallForOpportunityMatches } from '../../models/call-for-opportunity-matches';

export interface GetCallForOpportunityMatches$Params {
  companyId: string;
}

export function getCallForOpportunityMatches(http: HttpClient, rootUrl: string, params: GetCallForOpportunityMatches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CallForOpportunityMatches>>> {
  const rb = new RequestBuilder(rootUrl, getCallForOpportunityMatches.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CallForOpportunityMatches>>;
    })
  );
}

getCallForOpportunityMatches.PATH = '/matchesforcompany/{companyId}';
